import {useStyles} from '../../../../../shared/hooks/styles';

export default () =>
  useStyles(({isDesktop, theme}) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: theme.color.primaryNonGreyBackground,
      margin: 0,
      padding: 0,
      borderWidth: 0,
      borderColor: 'rgba(0, 0, 0, 0)',
      borderStyle: 'solid',
      borderRadius: 0,
    },
    touchEnableHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
    },
    header: {
      display: 'flex',
      width: '100%',
      height: isDesktop ? 125 : 62,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    title: {
      ...(isDesktop ? theme.fonts.h2 : theme.fonts.action),
      color: theme.color.textColor,
      padding: 0,
      marginRight: 15,
    },
    arrow: {
      padding: 0,
      margin: 0,
      transform: [{rotate: '-90deg'}],
    },
    arrowActive: {
      padding: 0,
      margin: 0,
      transform: [{rotate: '90deg'}],
    },
    description: {
      marginTop: isDesktop ? -20 : 0,
      marginBottom: 40,
    },
  }));
